import React from 'react';

const LeftArrow = props => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} xmlnsXlink="http://www.w3.org/1999/xlink" width="26" height="18" viewBox="0 0 26 18">
        <defs>
            <path id="vn8w90td1a" d="M0.06 0.287L25.195 0.287 25.195 17.999 0.06 17.999z" />
        </defs>
        <g fill="currentColor" fillRule="evenodd">
            <g transform="translate(-247 -1959) translate(50 1642) translate(18 41) translate(42 259) rotate(-180 81.5 17.5)">
                <mask id="01t1h3y3mb" fill="#fff">
                    <use xlinkHref="#vn8w90td1a" />
                </mask>
                <path fill="currentColor" d="M8.219.553c.355-.356.914-.356 1.269 0 .344.344.344.914 0 1.258L3.051 8.248h21.242c.496 0 .902.395.902.887 0 .496-.406.902-.902.902H3.051l6.437 6.426c.344.355.344.93 0 1.27-.355.355-.914.355-1.269 0L.258 9.772c-.344-.344-.344-.914 0-1.258L8.219.553z" mask="url(#01t1h3y3mb)" />
            </g>
        </g>
    </svg>
)

export default LeftArrow;